







































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { Debounce } from 'vue-debounce-decorator';
import { LinkedProduct } from '@/store/publications';
import { asyncForEach } from '@/utils';
import _, { forEach } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import products from '@/store/products';
import { directusApi } from '@/api';
import { publicationStoreBadge } from '@/utils';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'publication-detail-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('publications', ['activePublicationLoading', 'activePublication']),
        ...mapState('products', ['cacheProducts', 'cacheProductsLoading']),
    },
})
export default class PublicationDetailModal extends Vue {
    publicationStoreBadge = publicationStoreBadge;
    //
    private currentUser!: any;
    private cacheProducts!: any;
    private activePublication!: any;
    private activePublicationLoading!: any;
    private cost: any = {
        subtotal: 0,
        mercadolibre: 0,
        total: 0,
        stock_now: 0,
        stock_later: 0,
    };

    private cacheProductsLoading: any;
    private searchQuery: string = '';
    private mlCategoriesList: Array<any> = [];
    mlCategorySelected: any = null;
    private mlCategoryQuery: string = '';
    descriptionFirst: any = [];
    // descriptionFirst: string = '';
    descriptionSecond: string = '';
    descriptionThird: string = '';

    selected_warehouses: any = [];
    selected_channels: any = [];

    allSelected: boolean = false;
    variations_attributes: any = [
        // text:"Colores", value: null
    ];

    warehouses_options: any = [
        { text: 'O4', value: { warehouse: 'O4', day: 0 } },
        { text: 'M', value: { warehouse: 'M', day: 0 } },
        { text: 'I', value: { warehouse: 'I', day: 0 } },
        { text: 'U', value: { warehouse: 'U', day: 0 } },
        { text: 'UN +2', value: { warehouse: 'UN', day: 2 } },
        { text: 'A1 +1', value: { warehouse: 'A1', day: 1 } },
        { text: 'T6', value: { warehouse: 'T6', day: 0 } },
        { text: '1ML', value: { warehouse: '1ML', day: 0 } },
        { text: 'N1 +2', value: { warehouse: 'N1', day: 2 } },
        { text: 'S +1', value: { warehouse: 'S', day: 1 } },
        { text: 'T +3', value: { warehouse: 'T', day: 3 } },
        { text: 'N +2', value: { warehouse: 'N', day: 2 } },
        { text: 'S1 +1', value: { warehouse: 'S1', day: 1 } },
        { text: '1N +1', value: { warehouse: '1N', day: 1 } },
        { text: 'O7 +1', value: { warehouse: 'O7', day: 1 } },
        { text: 'C +2', value: { warehouse: 'C', day: 2 } },
        { text: 'UNC +1', value: { warehouse: 'UNC', day: 1 } },
        { text: 'JM +1', value: { warehouse: 'JM', day: 1 } },
    ];
    // { text: 'AR4 +1', value: { warehouse: 'AR4', day: 1 } }, //removed 23/04/2025
    channels: any = [
        { text: 'ML', value: 'marketplace' },
        { text: 'MSHOPS', value: 'mshops' },
    ];

    warehouses_options_code: any = [
        { warehouse: 'O4', day: 0 },
        { warehouse: 'M', day: 0 },
        { warehouse: 'I', day: 0 },
        { warehouse: 'U', day: 0 },
        { warehouse: 'UN', day: 2 },
        { warehouse: 'A1', day: 1 },
        { warehouse: 'T6', day: 0 },
        { warehouse: '1ML', day: 0 },
        { warehouse: 'N1', day: 2 },
        { warehouse: 'S', day: 1 },
        { warehouse: 'T', day: 3 },
        { warehouse: 'N', day: 2 },
        { warehouse: 'S1', day: 1 },
        { warehouse: '1N', day: 1 },
        { warehouse: 'O7', day: 1 },
        { warehouse: 'C', day: 2 },
        { warehouse: 'UNC', day: 1 },
        { warehouse: 'JM', day: 1 },
    ];

    charactersRemaining: number = 40;
    selected_variation_atts = [];

    attributesData = [];
    attVariations = [];
    selectAtt = [];
    selectAttText = false;
    isSelectDisabled: boolean = false;
    selectedColorIndex: any = null;

    get permalink() {
        //***************** setting default descriptions
        // console.log(this.activePublication);
        if (!this.activePublication.own_post) {
            this.charactersRemaining = 55;
        } else {
            this.charactersRemaining = 40;
        }
        this.descriptionThird =
            'Te armamos tu kit solo pídelo en la sección de preguntas y te generamos el enlace con precio especial \n\
Si tienes alguna duda, comentario o contratiempo con el envío o producto FAVOR DE CONTACTARNOS por mensaje privado ANTES DE INICIAR UN RECLAMO en el horario de atención.\n\
_______________\n\
::: PRODELEC MX :::\n\
Somos Mercado Líder Platinum, uno de los mejores vendedores de la plataforma por nuestra trayectoria y experiencia en el rubro.\n\
_______________\n\
::: MEDIOS DE ENVÍO :::\n\
• Envíos GRATIS a todo el País a través de Mercado Envíos y Mercado Envíos Full\n\
• El TIEMPO DE ENTREGA estimado es de 1 a 3 días hábiles a tu domicilio una vez despachada la mercadería\n\
• Al momento de la compra puedes seleccionar dónde recibir tu paquete (domicilio o alguna sucursal)\n\
_______________\n\
::: FACTURACIÓN :::\n\
• Contamos con FACTURACIÓN electrónica SIN COSTO extra\n\
• Nuestros precios publicados incluyen IVA\n\
• Para tu mayor comodidad y el cuidado del medio ambiente todas tus compras se ingresan en una sola factura\n\
_______________\n\
::: HORARIOS DE ATENCIÓN :::\n\
• Responderemos a tus pregunta de lunes a viernes de 8:30 a.m. a 6:00 p.m. Hora del Centro de México.\n\
_______________\n\
::: GARANTÍA :::\n\
• Nuestros productos son 100% originales\n\
•GARANTÍA contra defectos de fábrica\n\
_______________\n\
::: COMPRA PROTEGIDA :::\n\
Con el programa de Compra Protegida de Mercado Libre, tu dinero está seguro en cada momento con nosotros\n\
______________\n\
::: MÁS RAZONES PARA ELEGIRNOS :::\n\
• Somos Mercado líder Platinan, uno de los mejores vendedores en Mercado Libre por nuestra excelente calidad de productos y atención\n\
• Contamos con una AMPLIA VARIEDAD DE PRODUCTOS a los MEJORES PRECIOS del mercado\n\
• Brindamos ATENCIÓN PERSONALIZADA ofreciéndote siempre el mejor producto\n\
_______________\n\
::: ¿CÓMO COMPRAR FÁCIL Y RÁPIDO? :::\n\
1) Seleccionas tu producto y la cantidad que quieres comprar\n\
2) Una vez que hayas resuelto todas tus dudas das clic en el botón "COMPRAR"\n\
3) Si no realizas el pago de inmediato revisa tu correo, MercadoLibre le enviará un e-mail con instrucciones de pago\n\
4) Realizas tu pago y esperas la acreditación del mismo\n\
5) Se inicia el proceso de envío y esperas hasta que llegue a tu domicilio\n\
6) Calificas tu experiencia de compra con nosotros\n\
            ';
        //***************** ...
        if (this.activePublication.category != null) {
            this.activePublication.category.id
                ? (this.mlCategorySelected = this.activePublication.category)
                : this.$store.dispatch('publications/getCategoryAttributes', { category_id: '' }, (this.selectedColorIndex = null));
        }
        // console.log('without category');
        this.validateAttributes();
        this.validateVariationsAtt();
        this.calculateCost();
        if (this.activePublication.sync_warehouses) {
            this.selected_warehouses = this.activePublication.sync_warehouses;
        } else {
            this.selected_warehouses = [];
        }

        if (this.activePublication.channels) {
            this.selected_channels = this.activePublication.channels;
        } else {
            this.selected_channels = [];
        }
        return `https://www.mercadolibre.com.mx/publicaciones/listado/?search=${this.activePublication.id}`;
    }

    getProductUrl(id: string) {
        // return `https://www.prodelec.mx/tienda?title=${id}&similar=true`; // redirect to prodelec.mx
        return `https://www.prodelec.app/#/products?search=${id}&page=1`; // redirect to www.prodelec.app
    }

    mounted() {
        directusApi('GET', `items/mercadolibre_categories`)
            .then((response: any) => {
                this.mlCategoriesList = response.data.data;
                // console.log("mlCategoriesList", this.mlCategoriesList);
            })
            .catch((e) => console.log(e));
        setTimeout(() => {
            this.calculateCost();
        }, 1000);
    }

    toggleAll(checked: any) {
        console.log({ checked });

        this.selected_warehouses = checked ? this.warehouses_options_code.slice() : [];
    }
    toggleAllChannels(checked: any) {
        this.selected_channels = checked;
    }

    validateDiscount(variation_index: any, product_index: any) {
        let discount = 0;
        if (variation_index) {
            discount = +this.activePublication.variations[variation_index].linked_products[product_index].discount;
            discount > 10
                ? (this.activePublication.variations[variation_index].linked_products[product_index].discount = 10)
                : console.log('Descuento por debajo del limite');
        } else {
            discount = +this.activePublication.linked_products[product_index].discount;
            discount > 10 ? (this.activePublication.linked_products[product_index].discount = 10) : console.log('Descuento por debajo del limite');
        }
    }

    async calculateCost() {
        let product_totals_array: Array<number | undefined> = [];
        let product_stocks_array: Array<number | undefined> = [];
        let product_stocks_array_variations: Array<any | undefined> = [];
        let product_stocks_warehouse_now: Array<number | undefined> = [];
        let product_stocks_warehouse_later: Array<number | undefined> = [];

        // console.log(this.activePublication);
        if (this.activePublication.variations.length <= 0) {
            //simple publication
            await asyncForEach(this.activePublication.linked_products, async (linked_product: LinkedProduct) => {
                let stock_now = 0;
                let stock_later = 0;
                let qty = +linked_product.qty;
                let stock = +linked_product.stock;
                let discount = +linked_product.discount;
                let price = +linked_product.price;
                let iva = this.activePublication.iva;

                let subtotal = qty * price - qty * price * (discount / 100);
                let product_total = subtotal + subtotal * iva;

                // console.log({ product_total });

                let calculated_stock = Math.floor(stock / qty);

                // START Getting info to sync warehouses
                let warehouses_intersection = [];
                let warehouse_coincidence: any = [];

                // console.log(this.activePublication.sync_warehouses);

                this.activePublication.sync_warehouses.forEach((warehouse: any) => {
                    warehouse_coincidence = _.find(linked_product.warehouses, { warehouse: warehouse.warehouse });
                    warehouse_coincidence = {
                        ...warehouse_coincidence,
                        day: warehouse.day,
                    };
                    warehouses_intersection.push(warehouse_coincidence);
                });
                // console.log('Warehouses intersection : ', warehouses_intersection);
                // END Getting info to sync warehouses

                if (this.activePublication.sync_warehouses) {
                    // if (linked_product.warehouses) {
                    await asyncForEach(warehouses_intersection, async (warehouse: any) => {
                        warehouse.day == 0 ? (stock_now += +warehouse.stock) : (stock_later += +warehouse.stock);
                    });
                    // await asyncForEach(linked_product.warehouses, async (warehouse: any) => {
                    //     warehouse.stock_now ? (stock_now += +warehouse.stock) : (stock_later += +warehouse.stock);
                    // });
                }

                product_totals_array.push(product_total);
                product_stocks_array.push(calculated_stock);

                product_stocks_warehouse_now.push(Math.floor(stock_now / qty));
                product_stocks_warehouse_later.push(Math.floor(stock_later / qty));
            });
        } else {
            // console.log('variable');
            // variable publication
            await asyncForEach(this.activePublication.variations, async (variation: any) => {
                //
                let variation_product_stocks_array: any = [];
                let variation_product_totals_array: any = [];

                let variation_product_stocks_array_now = [];
                let variation_product_stocks_array_later = [];

                await asyncForEach(variation.linked_products, async (linked_product: LinkedProduct) => {
                    let stock_now = 0;
                    let stock_later = 0;
                    let qty = +linked_product.qty;
                    let stock = +linked_product.stock;
                    let discount = +linked_product.discount;
                    let price = +linked_product.price;
                    let iva = this.activePublication.iva;
                    let calculated_stock = 0;

                    let subtotal = qty * price - qty * price * (discount / 100);
                    let product_total = subtotal + subtotal * iva;

                    calculated_stock = qty === 0 ? (calculated_stock = 0) : (calculated_stock = Math.floor(stock / qty));
                    // let calculated_stock = Math.floor(stock / qty);

                    // START Getting info to sync warehouses
                    let warehouses_intersection = [];
                    let warehouse_coincidence: any = [];

                    // console.log(this.activePublication.sync_warehouses);

                    await asyncForEach(this.activePublication.sync_warehouses, async (warehouse: any) => {
                        warehouse_coincidence = _.find(linked_product.warehouses, { warehouse: warehouse.warehouse });
                        warehouse_coincidence = {
                            ...warehouse_coincidence,
                            day: warehouse.day,
                        };
                        warehouses_intersection.push(warehouse_coincidence);
                    });
                    // console.log('Warehouses intersection : ', warehouses_intersection);
                    // END Getting info to sync warehouses

                    if (this.activePublication.sync_warehouses) {
                        // if (linked_product.warehouses) {
                        await asyncForEach(warehouses_intersection, async (warehouse: any) => {
                            warehouse.day == 0 ? (stock_now += +warehouse.stock) : (stock_later += +warehouse.stock);
                        });
                        // if (linked_product.warehouses) {
                        //     await asyncForEach(linked_product.warehouses, async (warehouse) => {
                        //         warehouse.stock_now ? (stock_now += +warehouse.stock) : (stock_later += +warehouse.stock);
                        //     });
                    }

                    variation_product_stocks_array.push(calculated_stock);
                    variation_product_totals_array.push(product_total);

                    let variation_stock_now = 0;
                    let variation_stock_later = 0;
                    let variation_total = 0;
                    let variation_stock = 0;

                    if (qty === 0) {
                        variation_product_stocks_array_now = [];
                        variation_product_stocks_array_later = [];
                        product_stocks_array_variations.push({
                            id: variation.id,
                            stock_now: 0,
                            stock_later: 0,
                        });

                        variation_stock_now;
                        variation_stock_later;
                    } else {
                        variation_product_stocks_array_now.push(Math.floor(stock_now / qty));
                        variation_product_stocks_array_later.push(Math.floor(stock_later / qty));
                        product_stocks_array_variations.push({
                            id: variation.id,
                            stock_now: Math.floor(stock_now / qty),
                            stock_later: Math.floor(stock_later / qty),
                        });

                        variation_total = _.sum(variation_product_totals_array) == undefined ? 0 : _.sum(variation_product_totals_array);
                        variation_stock = _.min(variation_product_stocks_array) == undefined ? 0 : _.min(variation_product_stocks_array);

                        variation_stock_now = _.min(variation_product_stocks_array_now) == undefined ? 0 : _.min(variation_product_stocks_array_now);
                        variation_stock_later =
                            _.min(variation_product_stocks_array_later) == undefined ? 0 : _.min(variation_product_stocks_array_later);
                    }

                    product_totals_array.push(variation_total);
                    product_stocks_array.push(variation_stock);
                    product_stocks_warehouse_now.push(variation_stock_now);
                    product_stocks_warehouse_later.push(variation_stock_later);
                    //
                });

                //        variation_product_stocks_array.push(calculated_stock);
                //         variation_product_totals_array.push(product_total);

                //         variation_product_stocks_array_now.push(Math.floor(stock_now / qty));
                //         variation_product_stocks_array_later.push(Math.floor(stock_later / qty));

                //         product_stocks_array_variations.push({
                //             id: variation.id,
                //             stock_now: Math.floor(stock_now / qty),
                //             stock_later: Math.floor(stock_later / qty),
                //         });
                //     });

                //     let variation_total: any = _.sum(variation_product_totals_array) == undefined ? 0 : _.sum(variation_product_totals_array);
                //     let variation_stock: any = _.min(variation_product_stocks_array) == undefined ? 0 : _.min(variation_product_stocks_array);

                //     let variation_stock_now = _.min(variation_product_stocks_array_now) == undefined ? 0 : _.min(variation_product_stocks_array_now);
                //     let variation_stock_later =
                //         _.min(variation_product_stocks_array_later) == undefined ? 0 : _.min(variation_product_stocks_array_later);

                //     product_totals_array.push(variation_total);
                //     product_stocks_array.push(variation_stock);

                //     product_stocks_warehouse_now.push(variation_stock_now);
                //     product_stocks_warehouse_later.push(variation_stock_later);
            });
        }

        let final_subtotal: any = 0;
        let final_stock: number = 99999;

        let final_stock_warehouses_now = 99999;
        let final_stock_warehouses_later = 99999;

        // publication stock & subtotal
        if (this.activePublication.variations.length > 0) {
            // variable
            final_subtotal = _.max(product_totals_array) == undefined ? 0 : _.max(product_totals_array);
            final_stock = _.sum(product_stocks_array) == undefined ? 0 : (_.sum(product_stocks_array) as number);

            final_stock_warehouses_now = _.sum(product_stocks_warehouse_now) == undefined ? 0 : _.sum(product_stocks_warehouse_now);
            final_stock_warehouses_later = _.sum(product_stocks_warehouse_later) == undefined ? 0 : _.sum(product_stocks_warehouse_later);
        } else {
            // simple
            final_subtotal = _.sum(product_totals_array) == undefined ? 0 : _.sum(product_totals_array);
            final_stock = _.min(product_stocks_array) == undefined ? 0 : (_.min(product_stocks_array) as number);

            final_stock_warehouses_now = _.min(product_stocks_warehouse_now) == undefined ? 0 : _.min(product_stocks_warehouse_now);
            final_stock_warehouses_later = _.min(product_stocks_warehouse_later) == undefined ? 0 : _.min(product_stocks_warehouse_later);
        }

        let category_comission = 0;

        if (this.activePublication.category_id && final_subtotal > 0) {
            await this.$store.dispatch('publications/getCategoryCommission', {
                category_id: this.activePublication.category_id,
                price: final_subtotal,
                listing_type: this.activePublication.listing_type,
            });
            this.activePublication.categoryCommission =
                final_subtotal > this.activePublication.shipment_constant
                    ? this.activePublication.categoryCommission.sale_fee_amount / final_subtotal
                    : (this.activePublication.categoryCommission.sale_fee_amount - 25) / final_subtotal;

            category_comission = this.activePublication.categoryCommission > 0 ? this.activePublication.categoryCommission : 0.2;

            // if (this.activePublication.category) {
            //     console.log(this.activePublication.category);
            //     category_comission = this.activePublication.category.commission ? this.activePublication.category.commission : 0.2;
            // } else {
            //     this.activePublication.category = { commission: 0.2 };
            // }
        }

        //shipment_constant ==> 298.5
        //default_shipment_cost ==> 25
        //shipment_cost ==> 25

        // formula
        let constante_z = 1 / (1 - category_comission);
        let limite_envio = this.activePublication.shipment_constant / constante_z - this.activePublication.default_shipment_cost;
        let shipment_cost = final_subtotal > limite_envio ? this.activePublication.shipment_cost : 30;
        let final_total = +((Math.round((final_subtotal + shipment_cost) * constante_z) * 100) / 100).toFixed(2);

        let sync_up_price = false;
        let sync_up_stock = false;

        if (final_total > 7) {
            sync_up_price = true;
            if (this.activePublication.logistic_type != 'fulfillment') {
                sync_up_stock = true;
            }
        }

        // console.log("cost", {
        // 	id: this.activePublication.id,
        // 	logistic_type: this.activePublication.logistic_type,
        // 	sync_up_price,
        // 	sync_up_stock,
        // 	final_stock,
        // 	limite_envio,
        // 	shipment_cost,
        // 	final_subtotal,
        // 	final_total,
        // });
        this.cost.stock_now = final_stock_warehouses_now;
        this.cost.stock_later = final_stock_warehouses_later;
        this.cost.subtotal = final_subtotal;
        this.cost.mercadolibre = final_total - final_subtotal;
        this.cost.total = final_total;

        // console.log(this.activePublication.linked_products);
        this.descriptionFirst = []; //cleaning field to re-asign
        this.activePublication.linked_products.forEach((product: any) => {
            this.descriptionFirst.push({ data: '\n' + product.qty + 'u. ' + product.id });
            // this.descriptionFirst.push({ data: '\n' + product.qty + 'u. ' + product.id + ' ' + product.name });
        });
    }

    syncPriceMl(post) {
        this.$store.dispatch('publications/syncPost', { post: post });
    }

    onSetItem(product: any, parent: any, index: number) {
        parent.linked_products.splice(index, 1);
        parent.linked_products.push({
            new: false,
            qty: 1,
            discount: 0,
            ...product,
        });
        this.activePublication.linked_products.forEach((item: any) => {
            // console.log(item);
            if (item.id == product.id) {
                // console.log(item.gallery[0]);
                for (let i = 0; i < 8; i++) {
                    item.gallery[i].url = `https://directus.prodelec.app/assets/${item.gallery[i].id}`;
                    this.activePublication.gallery.unshift(item.gallery[i]);
                }
                // item.gallery[0].url = `https://directus.prodelec.app/assets/${item.gallery[0].id}`;
                // this.activePublication.gallery.unshift(item.gallery[0]);
            }
        });
        this.calculateCost();
    }

    clearCategory() {
        this.mlCategorySelected = null;
        this.activePublication.category = {};
        this.activePublication.category_id = '';
        this.attributesData = [];
    }

    setMlCategory($event: any) {
        // console.log('chosing a category');
        // console.log($event);
        this.mlCategorySelected = $event;
        this.activePublication.category = this.mlCategorySelected;
        this.activePublication.category_id = this.mlCategorySelected.id;
        this.$store.dispatch('publications/getCategoryAttributes', { category_id: this.activePublication.category_id });
        this.validateAttributes();
        this.validateVariationsAtt();
        this.calculateCost();
    }

    validateAttributes() {
        this.attributesData = [];
        if (!this.activePublication.id) {
            if (this.activePublication.categoryAttributes.length > 0) {
                this.activePublication.categoryAttributes.forEach((att: any) => {
                    this.attributesData.push({
                        id: att.id,
                        name: att.name,
                        value_name: null,
                    });
                });
            }
        }
    }
    validateVariationsAtt() {
        if (!this.activePublication.id) {
            if (this.activePublication.category_id) {
                if (this.activePublication.cat_variation && this.activePublication.cat_variation.length > 0) {
                    this.activePublication.cat_variation.forEach((att, index) => {
                        let options = [];
                        let exampleValue = '';
                        if (att.values) {
                            options = [
                                { text: att.name, value: null, disable: true },
                                ...att.values.map((at) => ({ text: at.name, value: at.id, disable: false })),
                            ];
                        } else {
                            if (att.example) {
                                options = [{ text: att.name, value: null, disable: true, example: att.example }];
                                exampleValue = att.example;
                            } else {
                                options = [{ text: att.name, value: null, disable: true }];
                            }
                        }
                        this.variations_attributes.push({
                            id: index,
                            value: null,
                            options_values: options,
                            example: exampleValue,
                        });
                    });

                    this.variations_attributes = _.uniqBy(this.variations_attributes, 'id');
                    console.log(this.variations_attributes);

                    this.selected_variation_atts = Array(this.variations_attributes.length).fill(null);
                    console.log(this.selected_variation_atts);

                    if (this.selectedColorIndex !== null && this.selectedColorIndex !== undefined) {
                        this.variations_attributes = this.variations_attributes.map((item, i) =>
                            i === this.selectedColorIndex ? { ...item, isDisabled: false } : { ...item, isDisabled: true }
                        );
                    }
                }
            } else {
                this.variations_attributes = [];
                this.activePublication.category_variations = [];
                this.activePublication.cat_variation = [];
            }
        } else {
            this.variations_attributes = [];
        }

        // console.log(this.variations_attributes);
        // console.log(this.selected_variation_atts);
        // console.log(this.activePublication.category_variations);
        // console.log(this.activePublication.cat_variation);

        // console.log(this.selectAttText);
    }

    categoryPredictor() {
        this.$store.dispatch('publications/categoryPredictor', { title: this.activePublication.title });
        // this.$bvModal.show('predictorCategoriesModal');
    }

    onGetCategory(category: any) {
        this.activePublication.category_id = category.id;
        this.activePublication.category = category;
        this.$store.dispatch('publications/getCategoryAttributes', { category_id: category.id });
        this.validateAttributes();
        this.validateVariationsAtt();
        this.$bvModal.hide('predictorCategoriesModal');
    }

    @Watch('activePublication.categoryPredictor')
    showPredictorModal() {
        this.$bvModal.show('predictorCategoriesModal');
    }

    async onSavePublication() {
        this.activePublication.channels = this.selected_channels;

        if (this.activePublication.id) {
            console.log('updating a ML post');

            let publicationDescription = '';
            this.descriptionFirst.forEach((productD: any) => {
                publicationDescription += productD.data;
            });
            publicationDescription += '\n' + this.descriptionSecond + '\n';
            publicationDescription += this.descriptionThird;

            this.$store.dispatch('publications/putOne', {
                publicationId: this.activePublication.id,
                autosync: this.activePublication.autosync,
                price_sync: this.activePublication.price_sync,
                stock_sync: this.activePublication.stock_sync,
                publicationData: this.activePublication,
                sync_warehouses: this.selected_warehouses,
                description: publicationDescription,
                store: this.activePublication.ml_store,
                channels: this.activePublication.channels,
            });
        } else {
            console.log('creating a ML post');
            let flagProducts = false;
            let flagAttributes = false;
            let flagVariations = false;

            // linked products validation ****************************
            this.activePublication.linked_products.forEach((product: any) => {
                if (product.new) {
                    flagProducts = true;
                }
            });
            // ****************************

            // attributes validation ****************************
            if (this.attributesData.length > 0) {
                this.attributesData.forEach((att: any) => {
                    if (att.value_name == null) {
                        flagAttributes = true;
                    }
                });
            }
            // ****************************

            // console.log(this.activePublication);
            // console.log(this.selected_variation_atts);
            // console.log(this.selectAtt);
            // console.log(this.selectAttText);

            // console.log(this.variations_attributes);

            // attributes variation validation ****************************
            // if(this.selected_variation_atts.length > this.selectAtt.length){
            //     flagVariations = true;
            // }

            if (this.selectAtt.length > 0) {
                this.selectAtt.forEach((att: any) => {
                    if (att.value == null || att.value === '') {
                        flagVariations = true;
                    }
                });
            } else {
                if (this.selectAtt.length == 0 && this.selectAttText == false) {
                    flagVariations = true;
                }
            }

            // ****************************
            if (
                !this.activePublication.title ||
                !this.activePublication.category_id ||
                this.activePublication.linked_products.length == 0 ||
                this.activePublication.channels.length == 0 ||
                !this.activePublication.officialStore ||
                flagProducts ||
                flagAttributes ||
                flagVariations
            ) {
                // console.log('title => ', this.activePublication.title);
                // console.log('category_id => ', this.activePublication.category_id);
                // console.log('length => ', this.activePublication.linked_products.length);
                // console.log('flagProducts => ', flagProducts);
                // console.log('flagAttributes => ', flagAttributes);
                this.$bvToast.toast('Por favor completa toda la información', {
                    title: `Datos insuficientes`,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            } else {
                console.log('build the body of a post for ML');
                // Publication title ***********************
                let publicationTitle = '';
                if (!this.activePublication.own_post) {
                    publicationTitle = this.activePublication.title;
                } else {
                    publicationTitle = 'PRODELEC ESPECIAL ' + this.activePublication.title;
                }
                // ***********************

                // Publication description ***********************
                let publicationDescription = '';
                this.descriptionFirst.forEach((productD: any) => {
                    publicationDescription += productD.data;
                });
                publicationDescription += '\n' + this.descriptionSecond + '\n';
                publicationDescription += this.descriptionThird;
                // ***********************
                // console.log({publicationDescription})

                // Publication linked_products ***********************
                let formatLinkedProducts = [];
                this.activePublication.linked_products.forEach((product: any) => {
                    formatLinkedProducts.push({
                        sku: product.id,
                        qty: +product.qty,
                        discount: +product.discount,
                    });
                });
                // ***********************

                // console.log(this.activePublication);
                // console.log(this.activePublication.cat_variation);

                // console.log(this.activePublication.category_variations);
                // console.log(this.activePublication);
                // console.log(this.selected_variation_atts);
                // console.log(this.selectAtt);

                this.$store.dispatch('publications/postOne', {
                    autosync: this.activePublication.autosync,
                    price_sync: this.activePublication.price_sync,
                    stock_sync: this.activePublication.stock_sync,
                    sync_warehouses: this.selected_warehouses,
                    publication: this.activePublication,
                    title: publicationTitle,
                    description: publicationDescription,
                    attributes: this.attributesData,
                    cost: this.cost,
                    linked_products: formatLinkedProducts,
                    user: this.currentUser,
                    channels: this.activePublication.channels,
                });
            }
        }
    }

    onAddItem(parent: any) {
        parent.linked_products.push({
            new: true,
        });
    }

    onRemoveItem(parent: any, index: any, product: any) {
        parent.linked_products.splice(index, 1);
        this.calculateCost();
        if (product.gallery) {
            let imgCoincidence = (element: any) => element.id == product.gallery[0].id;
            let indexRemove = this.activePublication.gallery.findIndex(imgCoincidence);
            this.activePublication.gallery.splice(indexRemove, 1);
        }
    }

    @Watch('selected_warehouses')
    @Debounce(100)
    updateCost() {
        this.activePublication.sync_warehouses = this.selected_warehouses;
        this.calculateCost();
    }

    resetAtt() {
        if (this.activePublication.title == '') {
            this.variations_attributes = [];
            this.selected_variation_atts = [];
            this.activePublication.category_variations = [];
            this.activePublication.cat_variation = [];
        }
    }

    @Watch('searchQuery')
    @Debounce(600)
    updateProductsList(search: string) {
        // console.log('searching...');
        // console.log(search);
        if (/\s/.test(this.searchQuery)) {
            //validation for one or many words
            const finalSentence = this.searchQuery.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
            this.searchQuery = finalSentence;
        } else {
            this.searchQuery = this.searchQuery.toUpperCase();
        }

        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAll', { search, limit: 40 });
        }
    }

    onFileChange(e: any) {
        if (e.target) {
            const files = e.target.files;
            files.forEach((file: any) => {
                let formData = new FormData();
                formData.append('image', file, file.name);
                this.activePublication.gallery = [
                    ...this.activePublication.gallery,
                    {
                        id: uuidv4(),
                        sort: null,
                        url: URL.createObjectURL(file),
                        origin: 'upload',
                        file: formData,
                        name: file.name,
                    },
                ];
            });
        } else {
            this.activePublication.gallery = [
                ...this.activePublication.gallery,
                {
                    id: e.id,
                    sort: null,
                    url: `https://directus.prodelec.app/assets/${e.id}`,
                    origin: 'directus-update',
                    file: null,
                },
            ];
        }
    }

    onRemoveImg(index: any) {
        this.activePublication.gallery.splice(index, 1);
    }

    onOpenFilesModal() {
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    updatePremium() {
        this.$store.dispatch('publications/updatePremium', this.activePublication);
    }

    onSelectedVariationsAtt(e, colors, disable, index) {
        this.selectedColorIndex = index;
        this.variations_attributes.map((item, i) => (i === index ? { ...item, isDisabled: true } : item));
        const selectedColor = colors.find((item) => item.value == e);
        if (selectedColor) {
            const newSelectedVariation = { id: colors[0].text, ...selectedColor };
            const existingIndex = this.selectAtt.findIndex((item) => {
                return item.id == newSelectedVariation.id;
            });
            existingIndex !== -1 ? (this.selectAtt[existingIndex] = newSelectedVariation) : this.selectAtt.push(newSelectedVariation);
            this.selectAtt = this.selectAtt.filter((item, index, self) => {
                return (
                    index ===
                    self.findIndex((obj) => {
                        return obj.id === item.id;
                    })
                );
            });

            this.selected_variation_atts.splice(index, 1, newSelectedVariation);
            this.selected_variation_atts = this.selected_variation_atts.map((item) =>
                item
                    ? item
                    : {
                        disable: true,
                        id: null,
                        text: 'default',
                        value: null,
                    }
            );

            let category_variations = this.selected_variation_atts
                .filter((item) => item)
                .map(({ id, text, value }) => ({ name: id, value_name: text, value_id: value }));
            category_variations = category_variations.filter((item) => item.value_id !== null);
            this.activePublication.category_variations = category_variations;
        } else {
            console.log('Color not found for value:', e);
        }
    }

    setValueText(e, attribute, att) {
        attribute.value = e;
        this.selectAtt = [attribute];
        this.selectAttText = true;

        let category_variations = this.selectAtt.map((item) => {
            return item.options_values.map((it) => {
                return {
                    name: it.text,
                    value_name: it.value,
                    value_id: null,
                };
            });
        });
        this.activePublication.category_variations = category_variations.flat();
    }
}
